import { render } from "./wnQuery.vue?vue&type=template&id=5bbe438b&scoped=true"
import script from "./wnQuery.vue?vue&type=script&lang=js"
export * from "./wnQuery.vue?vue&type=script&lang=js"

import "./wnQuery.vue?vue&type=style&index=0&id=5bbe438b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5bbe438b"

export default script